import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { PeriodType } from '@futrli/predict/core/constants';

interface ExportSuccessMessageProps {
  periodType?: PeriodType;
}

export const ExportSuccessMessage = ({ periodType }: ExportSuccessMessageProps) => {
  const intl = useIntl();

  return (
    <React.Fragment>
      <p data-testid="export-dialog-export-complete">
        <FormattedMessage
          id="predict.report_successfully_exported"
          defaultMessage="Your report has been successfully exported to Google Sheets."
        />
      </p>

      {periodType && (
        <React.Fragment>
          <br />
          <p data-testid="export-dialog-export-complete-period">
            <FormattedMessage
              id="predict.all_numbers_displayed_value_in_line"
              defaultMessage="All numbers will be displayed {thisPeriod} in line with how they are being displayed in Predict. Please change the view if you want these numbers to be exported {otherPeriod}."
              values={{
                thisPeriod:
                  periodType === 'MONTHLY'
                    ? intl.formatMessage({ id: 'common.monthly', defaultMessage: 'Monthly' }).toLocaleLowerCase()
                    : intl.formatMessage({ id: 'common.weekly', defaultMessage: 'Weekly' }).toLocaleLowerCase(),
                otherPeriod:
                  periodType === 'MONTHLY'
                    ? intl.formatMessage({ id: 'common.weekly', defaultMessage: 'Weekly' }).toLocaleLowerCase()
                    : intl.formatMessage({ id: 'common.monthly', defaultMessage: 'Monthly' }).toLocaleLowerCase()
              }}
            />
          </p>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
